var map = {
	"./hotkid.jpg": "s5jB",
	"./mum-mum.jpg": "h6zA",
	"./wangxing.jpg": "p8OB"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "sRTz";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/picture_show ^\.\/.*$
// module id = sRTz
// module chunks = 1